import { Component, EventEmitter, Input, Output } from '@angular/core';

export type EboAlertType = 'error' | 'warning' | 'success' | 'info' | 'feature';

@Component({
  selector: 'ebo-alert',
  templateUrl: './ebo-alert.component.html',
  styleUrls: ['./ebo-alert.component.scss']
})
export class EboAlertComponent {
  @Input() type: EboAlertType = 'error';
  @Input() title = '';
  @Input() description = '';
  @Input() hasActions = false;
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
